module.exports = __webpack_public_path__ + "img/hotelLogo-01.7b24dcfa.png";